import { getApiUrl } from 'constants/API'

/** STOMP-over-WebSocket endpoint exposed by the backend for the conversation domain. */
const WS_PATH = '/ws/conversations'

/**
 * Derives the conversation WebSocket URL from the REST API base URL.
 *
 * `getApiUrl()` may return an absolute http(s) URL (e.g. `https://api.dev.bkbn.com`) or a
 * same-origin relative path (e.g. `/api`). We resolve it against the current origin, swap the
 * scheme to ws(s) and append the WS path so the socket follows the same host/proxy as the REST API.
 */
export const getConversationSocketUrl = (): string => {
  const absolute = new URL(getApiUrl(), window.location.origin)
  const wsProtocol = absolute.protocol === 'https:' ? 'wss:' : 'ws:'
  const basePath = absolute.pathname.replace(/\/$/, '')

  return `${wsProtocol}//${absolute.host}${basePath}${WS_PATH}`
}
